import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const TimelineCard = (props) => {
  const { education, handleChange, handleDelete, hideActions } = props;

  const { t } = useTranslation();
  return (
    <div className="item-timeline">
      <div className="timeline-year">
        {" "}
        <span>
          {education?.start_date?.split("-")[0]} -{" "}
          {education?.end_date
            ? education?.end_date?.split("-")[0]
            : t("currentlyShort")}
        </span>
      </div>
      <div className="timeline-info">
        <h5 className="color-brand-1 mb-20">{education?.college?.name}</h5>
        <p className="color-text-paragraph-2 mb-15">
          {t("educationDegree")}: {education?.degree?.name} <br/>
          {t("educationGpa")}: {education?.gpa} <br/>
          {t("educationfieldOfStudy")}: {education?.field_of_study} <br/>
        </p>
      </div>
      {!hideActions && <div className="timeline-actions">
        {" "}
        <Link to={"#"} onClick={(e) => handleChange(education)} className="btn btn-editor position-inherit m-auto"></Link>
        <Link to="#" onClick={(e) => handleDelete(education)} className="btn btn-remove m-auto"></Link>
      </div>}
    </div>
  );
};

export default TimelineCard;
